import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  // i18next-http-backend: Carga traducciones desde un servidor.
  // Útil si deseas gestionar las traducciones de forma remota.
  .use(Backend)
  
  // Detecta el idioma del usuario utilizando i18next-browser-languagedetector.
  // Esto ayuda a definir el idioma predeterminado basado en la configuración del navegador.
  .use(LanguageDetector)
  
  // Pasa la instancia de i18n a react-i18next para la integración en React.
  .use(initReactI18next)
  
  // Inicializa i18next con opciones de configuración.
  .init({
    // Activa el modo debug en desarrollo para mostrar más detalles en la consola.
    // Descomentar si necesitas depuración.
    // debug: true,
    
    // Idioma de respaldo si el idioma detectado no está disponible.
    fallbackLng: "en",
    
    // Lista de idiomas soportados.
    supportedLngs: ["en", "de", "es", "it", "pt-BR"],
    
    // Permite que un valor vacío se cuente como inválido.
    returnEmptyString: false,
    
    // Configuración específica de React para la integración con i18next.
    react: {
      // Permite usar etiquetas HTML básicas en las traducciones con `<Trans>`.
      transSupportBasicHtmlNodes: true,
      
      // Mantiene ciertas etiquetas HTML básicas en las traducciones.
      transKeepBasicHtmlNodesFor: [
        "br", "strong", "i", "p", "vatican", "github", "mass", "osc", 
        "website", "app", "a", "kbd", "code", "footer", "githubicon",
      ],
    },
    
    // Configuración para la interpolación de valores dentro de las traducciones.
    interpolation: {
      // No es necesario escapar valores en React, ya que lo hace por defecto.
      escapeValue: false,
    },
  });

export default i18n;
